
      if (import.meta.env.VITE_ENV !== 'development') {
        console.log('Running analytics...');
        var script = document.createElement('script');
        script.defer = true;
        script.crossOrigin = 'anonymous';
        script.src =
          'https://cdn.markfi.xyz/scripts/analytics/0.11.24/cookie3.analytics.min.js';
        script.setAttribute('site-id', '8df01785-8ea6-4bd3-9b94-563af7931d8d');
        script.integrity =
          'sha384-ihnQ09PGDbDPthGB3QoQ2Heg2RwQIDyWkHkqxMzq91RPeP8OmydAZbQLgAakAOfI';
        document.getElementsByTagName('head')[0].appendChild(script);
      } else {
        console.log('Analytics disabled in dev mode.');
      }
    